const LeftPanelHeader = () => {
    return ( 
    <>
    <div className="left-panel__logo">
        <div className="left-panel__logo-title">CRM заявки</div>
        <div className="left-panel__logo-subtitle">учебный проект webcademy</div>
    </div>

    <div className="left-panel__user clearfix">
        <div className="left-panel__user-photo">
            <img src="img/avatars/avatar-128.jpg" alt="Avatar" />
        </div>
        <div className="left-panel__user-name">Петр <br />Васильевич</div>
    </div>    
    </>
    );
}
 
export default LeftPanelHeader;